import { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../../utils/styleHelpers';
import { ADJUSTMENT_NOTE_LIMIT } from './SupplierScoring.calc';

interface AdjustmentNoteDialogProps {
  functionLabel: string;
  rating: number;
  clientAverage: number;
  initialNote: string;
  onSave: (note: string) => void;
  onCancel: () => void;
}

/** Asks why a rating differs from the client average; the rating is kept only with an answer. */
export const AdjustmentNoteDialog = ({
  functionLabel,
  rating,
  clientAverage,
  initialNote,
  onSave,
  onCancel
}: AdjustmentNoteDialogProps) => {
  const [note, setNote] = useState(initialNote);
  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      onClose={onCancel}>
      <DialogTitle>Why does your rating differ?</DialogTitle>
      <DialogContent className="flex flex-col gap-3">
        <TextBlock
          size="sm"
          color="grey8">
          You rated {functionLabel} {rating}; clients averaged {clientAverage}.
        </TextBlock>
        <TextField
          required
          multiline
          minRows={3}
          label="Justification note"
          value={note}
          inputProps={{ maxLength: ADJUSTMENT_NOTE_LIMIT }}
          onChange={(event) => setNote(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <button
          type="button"
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className={DEFAULT_ADVANCE_BUTTON_STYLE}
          disabled={!note.trim()}
          onClick={() => onSave(note.trim())}>
          Save
        </button>
      </DialogActions>
    </Dialog>
  );
};
